import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import startsWith from 'lodash/startsWith';

import { ButtonGroup } from '../button-group/button-group';
import { Button } from '../button/button';

interface Option {
  key: string;
  label: string;
  to: string;
  prefix: string;
}

interface TabbedButtonsProps {
  options: Option[];
  matchRouteKey: string;
}

export const BaseRouteTabbedButtons = ({
  matchRouteKey,
  options,
}: TabbedButtonsProps) => {
  const navigate = useNavigate();
  return (
    <ButtonGroup size="small">
      {options.map((item) => {
        const matched = startsWith(matchRouteKey, item.prefix);
        return (
          <Button
            key={item.key}
            variant={matched ? 'contained' : 'outlined'}
            onClick={() => navigate(item.to)}
          >
            {item.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export const RouteTabbedButtons = memo(BaseRouteTabbedButtons);

export default RouteTabbedButtons;
